/**
 * Utility Functions
 */

// Calculate vt-container left spacing dynamically
export function initVTContainerSpacing() {
    function calculateVTContainerLeftSpacing() {
        var container = document.querySelector('.vt-container');
        if (!container) return;

        var containerRect = container.getBoundingClientRect();
        var computedStyle = getComputedStyle(container);
        var containerLeft = containerRect.left;
        var containerPaddingLeft = parseFloat(computedStyle.paddingLeft);
        var leftSpacing = containerLeft + containerPaddingLeft;

        document.documentElement.style.setProperty('--vt-container-left-spacing', leftSpacing + 'px');
        container.style.setProperty('--vt-container-left-spacing', leftSpacing + 'px');
    }

    calculateVTContainerLeftSpacing();
    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(calculateVTContainerLeftSpacing, 100);
    });
}

// Scroll to Top Button
export function initScrollToTop() {
    var scrollToTopBtn = document.getElementById('scroll-to-top');
    if (!scrollToTopBtn) return;

    function getScrollThreshold() {
        return window.innerWidth < 768 ? 700 : 1000;
    }
    var scrollThreshold = getScrollThreshold();

    window.addEventListener('resize', function() {
        scrollThreshold = getScrollThreshold();
    });

    function toggleButton() {
        if (window.scrollY > scrollThreshold) {
            scrollToTopBtn.classList.remove('opacity-0', 'invisible', 'translate-y-4');
            scrollToTopBtn.classList.add('opacity-100', 'visible', 'translate-y-0');
        } else {
            scrollToTopBtn.classList.add('opacity-0', 'invisible', 'translate-y-4');
            scrollToTopBtn.classList.remove('opacity-100', 'visible', 'translate-y-0');
        }
    }

    function smoothScrollToTop() {
        var startPosition = window.scrollY;
        var startTime = null;
        var duration = 1800;

        function customEase(t) {
            if (t < 0.7) {
                return (t / 0.7) * 0.9;
            } else {
                var remaining = (t - 0.7) / 0.3;
                return 0.9 + (remaining * 0.1);
            }
        }

        function animateScroll(currentTime) {
            if (startTime === null) startTime = currentTime;
            var elapsed = currentTime - startTime;
            var progress = Math.min(elapsed / duration, 1);
            var easeProgress = customEase(progress);
            var currentPosition = startPosition * (1 - easeProgress);

            window.scrollTo(0, currentPosition);

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        }

        requestAnimationFrame(animateScroll);
    }

    scrollToTopBtn.addEventListener('click', smoothScrollToTop);

    var ticking = false;
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                toggleButton();
                ticking = false;
            });
            ticking = true;
        }
    });

    toggleButton();
}

